import { GLServiceBase, ServiceRoute } from "commonui";
import { IQuickViewWindowService, QuickViewContentModel, QuickViewExposureModel } from ".";

class QuickViewWindowServiceClass extends GLServiceBase<any, any> implements IQuickViewWindowService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcs" };

	getContentText(id: string): Promise<QuickViewContentModel> {
		return this.get("{contentId}/GetContentTextQuickView", { contentId: id });
	}
	getExposure(id: string): Promise<QuickViewExposureModel> {
		return this.get("{exposureId}/GetContentExposureQuickView", { exposureId: id });
	}
}

export const QuickViewWindowService = new QuickViewWindowServiceClass();
